import { Flex, FlexProps, Text, VStack } from '@chakra-ui/react';
import { IIconProps } from '~/components/Icon';
import { FemaleIcon, MaleIcon } from '~/components/icons';

import { GENDERS } from './GenderLabel.types';

interface Props extends FlexProps {
  gender: GENDERS;
  value: string;
}

const GENDER_ICON_COMPONENT = {
  [GENDERS.Male]: (props: IIconProps) => (
    // @ts-ignore
    <MaleIcon color="tertiary.500" {...props} />
  ),
  [GENDERS.Female]: (props: IIconProps) => (
    // @ts-ignore
    <FemaleIcon color="secondary.500" {...props} />
  ),
};

export const GenderLabel: React.FC<Props> = ({ gender, value, ...props }) => {
  const Icon = GENDER_ICON_COMPONENT[gender];
  const genderLabel = gender === GENDERS.Female ? GENDERS.Female : GENDERS.Male;

  return (
    <Flex alignItems="center" data-testid={`gender-${genderLabel}`} {...props}>
      <Icon width="12.5px" height={6} />

      <VStack spacing={0} marginLeft="15.62px" alignItems="flex-start">
        <Text
          textTransform="capitalize"
          fontSize="md"
          lineHeight="17px"
          letterSpacing="wide"
          color="neutral.400"
        >
          {gender}
        </Text>
        <Text
          fontWeight="medium"
          textTransform="uppercase"
          lineHeight="19px"
          letterSpacing="wide"
          fontSize="lg"
        >
          {value}
        </Text>
      </VStack>
    </Flex>
  );
};
